import { render, staticRenderFns } from "./OneTimeNoRideItem.vue?vue&type=template&id=393bd69c"
import script from "./OneTimeNoRideItem.vue?vue&type=script&lang=js"
export * from "./OneTimeNoRideItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports